import { LoadingButton } from '@mui/lab'
import { Alert, Link, Stack, TextField } from '@mui/material'
import { Fragment } from 'react'
import { AuthFormHeader } from '../FormHeader'

interface CreateAccountFormProps {
  render?: string[]
  slots?: {
    Form?: React.ElementType
    Header?: React.ElementType
    FirstnameInput?: React.ElementType
    LastnameInput?: React.ElementType
    Button?: React.ElementType
  }
  slotProps?: {
    Form?: any
    Header?: any
    FirstnameInput?: any
    LastnameInput?: any
    Button?: any
    AuthenticatedBanner?: any
  }
}

export function CreateAccountForm(props: CreateAccountFormProps) {
  const { render = [], slots, slotProps } = props

  const Slots = {
    Form: Fragment,
    Header: AuthFormHeader,
    FirstnameInput: TextField,
    LastnameInput: TextField,
    Button: LoadingButton,
    ...slots
  }

  return (
    <>
      <Slots.Header
        title='Create your free account'
        {...slotProps?.Header}
      />

      <Stack
        component={Slots.Form}
        direction='column'
        spacing={3}
        {...slotProps?.Form}
      >
        <Slots.FirstnameInput
          label='First name'
          {...slotProps?.FirstnameInput}
        />

        <Slots.LastnameInput
          label='Last name'
          {...slotProps?.LastnameInput}
        />

        {render.includes('authenticated') ? (
          <Alert severity='warning'>
            Signing up as{' '}
            <b>
              {slotProps?.AuthenticatedBanner?.email || 'company@name.com'}.{' '}
            </b>
            <Link
              href='/sign-out'
              color='secondary'
              underline='always'
              onClick={slotProps?.AuthenticatedBanner?.onActionClick}
            >
              Sign out
            </Link>
          </Alert>
        ) : null}

        <Slots.Button
          color='primary'
          variant='contained'
          type='submit'
          size='large'
          sx={{
            borderRadius: 99
          }}
          {...slotProps?.Button}
        >
          Continue
        </Slots.Button>
      </Stack>
    </>
  )
}
